import React from "react";
import efg_logo from "../../assets/img/efglogo.png";
import Dropdown from "../dropdown/Dropdown";
import insta from "../../assets/icons/Instagram.svg";
import fb from "../../assets/icons/Facebook.svg";
import tweet from "../../assets/icons/Twitter.svg";
import youtube from "../../assets/icons/youtube.svg";
import linkedin from "../../assets/icons/linkedn.svg";
// import { Link } from "react-router-dom";
// import { NavHashLink } from "react-router-hash-link";
import { HashLink } from "react-router-hash-link";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail, MdOutlineEmail } from "react-icons/md";
import { FaLocationDot, FaSquareXTwitter } from "react-icons/fa6";

const Footer = () => {
  return (
    <>
      <div className="border-black border-t-[1px]">
        <div className=" text-black w-[100vw] text-left pt-10 pb-4 desktop:px-4 lg:block ">
          <div className="flex pb-8 mx-auto tab2:flex-col justify-evenly tab2:w-11/12">
            {/* company info */}
            <div className="leading-5">
              <div className="flex items-center pb-2 mobile:flex-col mobile:items-start">
                <div className="pt-1 ml-0">
                  <h3 className="text-xl font-medium mobile:text-base">
                    Euro Foods Group
                  </h3>
                  <p className="mobile:text-xs">Bangladesh Operation</p>
                </div>
              </div>
              <div className="flex flex-col">
                <h3 className="py-2 text-xl font-medium tab2:underline mobile:text-base">
                  Head Office:
                  <hr className="p-[1px] w-[122px] bg-black tab2:hidden" />
                </h3>
                <div className="flex py-4">
                  <FaLocationDot className="text-black mr-2" />
                  <p className="mobile:text-xs">
                    Navana Oval, 7th Floor, <br /> Plot-5, Sonargaon Janapath
                    Road, <br /> Sector-07, Uttara, Dhaka
                  </p>
                </div>

                <div className="flex items-center">
                  <MdEmail className="text-black mr-2" />
                  <p className="py-2 mobile:text-xs">info@eurofoods-bd.com</p>
                </div>
                <div className="flex items-center">
                  {/* <svg
                    className="fill-[#000]"
                    x="0px"
                    y="0px"
                    width="25px"
                    height="25px"
                    viewBox="0 0 92 92"
                    enableBackground="new 0 0 92 92"
                  >
                    <path
                      d="M46,0C20.6,0,0,20.6,0,46s20.6,46,46,46s46-20.6,46-46S71.4,0,46,0z M49.7,83.8c-0.2,0-0.4,0-0.7,0.1V62.2
	c5.2-0.1,9.9-0.2,14.2-0.5C59.4,73.4,52.3,81.2,49.7,83.8z M42.3,83.8c-2.7-2.7-9.7-10.5-13.5-22.1c4.2,0.3,9,0.5,14.2,0.5v21.7
	C42.8,83.9,42.6,83.8,42.3,83.8z M8,46c0-2.5,0.3-5,0.7-7.4c2.2-0.4,6.4-1,12.3-1.6c-0.5,2.9-0.8,5.9-0.8,9.1c0,3.2,0.3,6.2,0.7,9
	c-5.8-0.6-10.1-1.2-12.3-1.6C8.3,51,8,48.5,8,46z M26.3,46c0-3.4,0.4-6.6,1-9.6c4.6-0.3,9.8-0.6,15.7-0.6v20.4
	c-5.8-0.1-11.1-0.3-15.8-0.7C26.7,52.6,26.3,49.4,26.3,46z M49.6,8.2c2.7,2.7,9.6,10.7,13.5,22.1c-4.2-0.3-8.9-0.5-14.1-0.5V8.1
	C49.2,8.1,49.4,8.2,49.6,8.2z M43,8.1v21.7c-5.2,0.1-9.9,0.2-14.1,0.5c3.8-11.4,10.8-19.4,13.4-22.1C42.6,8.2,42.8,8.1,43,8.1z
	 M49,56.2V35.8c5.8,0.1,11.1,0.3,15.7,0.6c0.6,3,1,6.2,1,9.6c0,3.4-0.3,6.6-0.9,9.6C60.2,55.9,54.9,56.1,49,56.2z M70.9,37
	c5.9,0.6,10.1,1.2,12.3,1.6C83.7,41,84,43.5,84,46c0,2.5-0.3,5-0.7,7.4c-2.2,0.4-6.4,1-12.3,1.6c0.5-2.9,0.7-5.9,0.7-9.1
	C71.7,42.9,71.4,39.8,70.9,37z M81.4,32.2c-2.8-0.4-6.8-0.9-11.9-1.4c-2.4-8.6-6.6-15.5-10.1-20.4C69.5,14.2,77.5,22.2,81.4,32.2z
	 M32.6,10.4c-3.6,4.8-7.7,11.7-10.1,20.3c-5,0.4-9,1-11.9,1.4C14.5,22.2,22.6,14.2,32.6,10.4z M10.6,59.8c2.8,0.4,6.8,0.9,11.8,1.4
	c2.4,8.6,6.4,15.5,10,20.3C22.4,77.6,14.5,69.7,10.6,59.8z M59.6,81.5c3.6-4.8,7.6-11.6,10-20.2c5-0.4,9-1,11.8-1.4
	C77.5,69.7,69.6,77.6,59.6,81.5z"
                    />
                  </svg> */}
                </div>
                <div className="flex items-center">
                  <FaPhoneAlt className="text-black mr-2" />
                  <p className="py-2 mobile:text-xs">+880248955205</p>
                </div>
                <div className="flex items-center">
                  <FaPhoneAlt className="text-black mr-2" />
                  <p className=" mobile:text-xs"> +880248955206</p>
                </div>
              </div>
            </div>
            {/* quick links */}
            <div className="hidden">
              <div className="flex flex-col leading-10 mobile:text-center">
                <div className="py-5 font-medium">
                  <h1 className="text-xl text-center mobile:text-base">
                    Quick Links
                    <hr className="mx-14" />
                  </h1>
                </div>
                <a href="#" className="desktop:text-base mobile:text-xs">
                  Brands
                </a>
                <a href="#" className="desktop:text-base mobile:text-xs">
                  Our Mission
                </a>
                <a href="#" className="desktop:text-base mobile:text-xs">
                  Our Services
                </a>
                <a href="#" className="desktop:text-base mobile:text-xs">
                  Awards & Certificates
                </a>
                <a href="#" className="desktop:text-base mobile:text-xs">
                  News & Articles
                </a>
                <a href="#" className="desktop:text-base mobile:text-xs">
                  EFG at a glance
                </a>
              </div>
            </div>
            {/* brands here */}
            <div className="hidden">
              <div className="leading-10">
                <div className="py-5 font-medium text-center">
                  <h3 className="text-xl">Brands</h3>
                  <hr className="mx-14" />
                </div>
                <div className="flex items-center justify-start mobile:justify-center">
                  <div className="mr-2 bg-white rounded-2xl">
                    <img className="px-1" width="50px" src={efg_logo} alt="" />
                  </div>
                  <a href="#" className="desktop:text-base">
                    EFG Fashion
                  </a>
                </div>
                <div className="flex items-center justify-start mobile:justify-center">
                  <div className="mr-2 bg-white rounded-2xl">
                    <img className="px-1" width="50px" src={efg_logo} alt="" />
                  </div>
                  <a href="#" className="desktop:text-base">
                    Rosemco
                  </a>
                </div>
                <div className="flex items-center justify-start mobile:justify-center">
                  <div className="mr-2 bg-white rounded-2xl">
                    <img className="px-1" width="50px" src={efg_logo} alt="" />
                  </div>
                  <a href="#" className="desktop:text-base">
                    Al-rohim
                  </a>
                </div>
                <div className="flex items-center justify-start mobile:justify-center">
                  <div className="mr-2 bg-white rounded-2xl">
                    <img className="px-1" width="50px" src={efg_logo} alt="" />
                  </div>
                  <a href="#" className="desktop:text-base">
                    Zoy
                  </a>
                </div>
                <div className="flex items-center justify-start mobile:justify-center">
                  <div className="mr-2 bg-white rounded-2xl">
                    <img className="px-1" width="50px" src={efg_logo} alt="" />
                  </div>
                  <a href="#" className="desktop:text-base">
                    masala
                  </a>
                </div>
              </div>
            </div>
            {/* about us */}
            <div className="flex flex-col leading-10">
              <div className="py-5 font-medium text-left">
                <h3 className="text-xl tab2:underline tab2:text-left mobile:text-base">
                  About us
                </h3>
                <hr className="p-[1px] bg-black w-[92px] tab2:hidden" />
              </div>
              <a
                href="/aboutus"
                className="desktop:text-base mobile:text-xs hover:text-red-500"
              >
                About EFG
              </a>
              <HashLink to="/aboutus#mission">
                <p className="desktop:text-base mobile:text-xs hover:text-red-500">
                  Mission, Vision & Value
                </p>
              </HashLink>
              <a
                href="/career"
                className="desktop:text-base mobile:text-xs hover:text-red-500"
              >
                Career
              </a>
              <a
                href="/contactus"
                className="desktop:text-base mobile:text-xs hover:text-red-500"
              >
                Contact Us
              </a>
            </div>
            {/* initiative sections here */}
            <div className="flex flex-col leading-10">
              <div className="py-5 font-medium text-left tab2:pl-0">
                <h3 className="px-0 text-xl tab2:underline tab2:text-left mobile:text-base">
                  Projects & Initiatives
                </h3>
                <hr className="w-[222px] p-[1px] bg-black tab2:hidden" />
              </div>
              <a
                href="/projects"
                className="desktop:text-base mobile:text-xs hover:text-red-500"
              >
                Upcoming Projects
              </a>
              <div className="py-5 mt-16 font-medium text-left tab2:pl-0">
                <h3 className="text-xl tab2:underline tab2:text-left mobile:text-base">
                  Follow Us on:
                </h3>
                <hr className="w-[128px] p-[1px] bg-black tab2:hidden" />
              </div>
              <div className="flex items-center justify-between mt-4 mobs:mx-10 mobile:mx-20 tab2:mx-36">
                <a href="https://www.facebook.com/eurofoodsgroup.bd" target="_blank" rel="noreferrer">
                  <img className="w-8" src={fb} alt="facebook icon" />
                </a>
                <a href="https://x.com/eurofoodsgroup?lang=en" target="_blank" rel="noreferrer">
                  <FaSquareXTwitter className="w-8 text-4xl" />
                </a>
                <a href="https://www.instagram.com/eurofoodsdirect?igsh=MTd2Z2F4cjFiZTBpZQ==" target="_blank" rel="noreferrer">
                  <img className="w-8" src={insta} alt="instagram icon" />
                </a>
                <a href="https://www.linkedin.com/company/eurofoods/posts/?feedView=all" target="_blank" rel="noreferrer">
                  <img className="w-8" src={linkedin} alt="linkedin icon" />
                </a>
                <a href="https://www.youtube.com/@EuroFoodsGroup" target="_blank" rel="noreferrer">
                  <img className="w-8" src={youtube} alt="youtube icon" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="hidden lg:hidden sm:hidden">
          <Dropdown img="new"></Dropdown>
        </div>

        <div className="flex justify-end py-3 bg-[#FFCD72]">
          {/* social icons */}

          {/* Copyright */}
          <div className="flex md:pt-2 lg:pt-0 items-center lg:pr-[75px] justify-center tablet:mt-2">
            <div className="hover:text-[#000] mobile:text-sm">
              <p className="inline-block pr-1 mobile:text-[10px]">Developed</p>
              <p className="inline-block pr-1 mobile:text-[10px]">By:</p>
            </div>
            {/* <div className="pr-[1px] py-2 bg-[#000]"></div> */}
            <div className="hover:text-[#000] mobile:text-sm">
              <p className="inline-block pl-0 mobile:text-[10px]">EFG</p>
              <p className="inline-block px-1 mobile:text-[10px]">TECH</p>
            </div>
            <div className="pr-[1px] py-2 bg-[#000]"></div>

            <p className="pl-1 mobile:text-[10px]">Copyright</p>
            <p className="mobile:text-[10px]"> &copy; </p>
            <p className="mobile:text-[10px]">
              {new Date().getFullYear()}. Euro
            </p>
            <p className="pl-1 mobile:text-[10px]">Foods</p>
            <p className="pl-1 mobile:text-[10px]">Group</p>
            <p className="pl-1 mobile:text-[10px]">Ltd.</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
